// commonspace ページ固有スクリプト
export default class commonspacePage {
  constructor() {
    this.publicSlider();
  }

  // publicSect の切替スライダー（Swiper 不使用）。
  // 一定時間で画像・右下テキスト・画像内キャプションを切替。サムネクリックでも切替。
  // 左の見出しは共通なので切替対象外。
  publicSlider() {
    const root = document.querySelector('.js-publicSlider');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('.js-publicSlider-slide'));
    const thumbs = Array.from(root.querySelectorAll('.js-publicSlider-thumb'));
    const bodies = Array.from(root.querySelectorAll('.js-publicSlider-body'));
    const count = slides.length;
    if (count < 2) return;

    const INTERVAL = 5000;
    let index = 0;
    let timer = null;

    const setActive = (next) => {
      index = (next + count) % count;
      slides.forEach((el, i) => el.classList.toggle('is-active', i === index));
      thumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
      bodies.forEach((el, i) => el.classList.toggle('is-active', i === index));
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const start = () => {
      stop();
      timer = setInterval(() => setActive(index + 1), INTERVAL);
    };

    // サムネクリックで切替＋タイマーリセット
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        setActive(i);
        start();
      });
    });

    start();
  }
}
